var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79642 17.4974C7.38403 18.016 8.15591 18.3307 9.00128 18.3307C9.84665 18.3307 10.6185 18.016 11.2061 17.4974M14.0013 6.66406C14.0013 5.33798 13.4745 4.06621 12.5368 3.12853C11.5991 2.19085 10.3274 1.66406 9.00128 1.66406C7.6752 1.66406 6.40343 2.19085 5.46574 3.12853C4.52806 4.06621 4.00128 5.33798 4.00128 6.66406C4.00128 9.23922 3.35167 11.0024 2.626 12.1686C2.01388 13.1523 1.70783 13.6442 1.71905 13.7814C1.73147 13.9333 1.76366 13.9912 1.88609 14.082C1.99666 14.1641 2.4951 14.1641 3.49199 14.1641H14.5106C15.5075 14.1641 16.0059 14.1641 16.1165 14.082C16.2389 13.9912 16.2711 13.9333 16.2835 13.7814C16.2947 13.6442 15.9887 13.1523 15.3766 12.1686C14.6509 11.0024 14.0013 9.23922 14.0013 6.66406Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell01);
export default __webpack_public_path__ + "static/media/bell-01.9773d4f9cf8a52a11de7f72618d41b7e.svg";
export { ForwardRef as ReactComponent };